import { Col, Modal, Row } from 'antd';
import i18n from 'i18next';

import { ENV_VARS } from '@/env';

import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg';
import { ReactComponent as WarningIcon } from '../../../assets/icons/warning.svg';
import Button from '../Buttons/Button';
import IconButton from '../Buttons/IconButton';
import SvgConverter from '../Common/SvgConverter';

const WarningModal = ({
  open = false,
  okText = i18n.t('translation:default.options.ok'),
  description = i18n.t('translation:default.fields.description'),
  onClose = () => {},
  onOk = () => {},
  okButtonVariant = 'primary',
  alertTitle = i18n.t('translation:default.fields.alert'),
}) => {
  return (
    <Modal
      rootClassName="common-warning-modal"
      className="common-confirmation-modal"
      closable={false}
      centered
      footer={false}
      open={open}
      style={{ zIndex: 99999999999999 }}
    >
      <Row
        className={`header-section ${ENV_VARS.REACT_APP_THEME === 'halliburton' ? 'hb-bg-color' : ''}`}
        justify="space-between"
        align="middle"
      >
        <Col>
          <label className="title">
            <SvgConverter Icon={WarningIcon} color="white" width={17} height={17} className="mr-5" />
            {alertTitle}
          </label>
        </Col>
        <Col className="lh-0">
          <IconButton onClick={onClose}>
            <SvgConverter Icon={CloseIcon} color="white" />
          </IconButton>
        </Col>
      </Row>
      <div className="content-section">
        <div className="description">{description}</div>
        <Row className="footer-section" justify="end">
          <Col>
            <Row gutter={20}>
              <Col>
                <Button
                  variant={okButtonVariant}
                  onClick={onOk}
                  className={ENV_VARS.REACT_APP_THEME === 'halliburton' ? 'hb-button' : ''}
                >
                  {okText}
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

export default WarningModal;
